interface LineSeparatedProps {
  keyy: React.ReactNode;
  value: React.ReactNode;
}

export function LineSeparated({ keyy, value }: LineSeparatedProps) {
  return (
    <div>
      <dt className="text-sm font-medium text-muted">{keyy}</dt>
      <dd className="text-sm text-default">{value}</dd>
    </div>
  );
}
